module.exports = __webpack_public_path__ + "img/limited.019eaf5c.svg";